import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box
} from "@mui/material";
import ImagePreviewBox from "../../components/common/ImagePreviewBox";
import DocStatusSelect from "./DocStatusSelect";
import { VerifiedForm } from "./driverTypes";

interface Props {
  open: boolean;
  onClose: () => void;
  form: VerifiedForm;
  setForm: React.Dispatch<React.SetStateAction<VerifiedForm>>;
  onSave: () => void;
}

/** Compliance documents modal (Insurance / PUC / State Permit / AITP). */
const DriverComplianceModal: React.FC<Props> = ({ open, onClose, form, setForm, onSave }) => (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" disableEnforceFocus>
      <DialogTitle>Verify Compliance Documents</DialogTitle>
      <DialogContent>
        <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' },
              gap: 3,
              alignItems: 'center',
              py: 2,
            }}
        >
          {/* Row 4: Insurance */}
          <TextField
              label="Insurance No."
              value={form.insuranceNumber || ""}
              onChange={e => setForm(prev => ({ ...prev, insuranceNumber: e.target.value }))}
              fullWidth
              size="small"
          />
          <ImagePreviewBox imageUrls={form.insuranceUrls} altText="Insurance" />
          <DocStatusSelect
              label="Insurance Status"
              value={form.insuranceStatus}
              onChange={(val) => setForm(prev => ({ ...prev, insuranceStatus: val }))}
          />

          {/* Row 5: PUC */}
          <TextField
              label="PUC Number"
              value={form.pucNumber || ""}
              onChange={e => setForm(prev => ({ ...prev, pucNumber: e.target.value }))}
              fullWidth
              size="small"
          />
          <ImagePreviewBox imageUrls={form.pucUrls} altText="PUC" />
          <DocStatusSelect
              label="PUC Status"
              value={form.pucStatus}
              onChange={(val) => setForm(prev => ({ ...prev, pucStatus: val }))}
          />

          {/* Row 6: State Permit */}
          <TextField
              label="Permit No."
              value={form.statePermitNumber || ""}
              onChange={e => setForm(prev => ({ ...prev, statePermitNumber: e.target.value }))}
              fullWidth
              size="small"
          />
          <ImagePreviewBox imageUrls={form.statePermitUrls} altText="Permit" />
          <DocStatusSelect
              label="Permit Status"
              value={form.statePermitStatus}
              onChange={(val) => setForm(prev => ({ ...prev, statePermitStatus: val }))}
          />

          {/* Row 7: AITP */}
          <TextField
              label="AITP Number"
              value={form.aitpNumber || ""}
              onChange={e => setForm(prev => ({ ...prev, aitpNumber: e.target.value }))}
              fullWidth
              size="small"
          />
          <ImagePreviewBox imageUrls={form.aitpUrls} altText="AITP" />
          <DocStatusSelect
              label="AITP Status"
              value={form.aitpStatus}
              onChange={(val) => setForm(prev => ({ ...prev, aitpStatus: val }))}
          />

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSave}>
          Save Compliance
        </Button>
      </DialogActions>
    </Dialog>
);

export default DriverComplianceModal;
